import {Modal, ModalFuncProps} from 'antd';

/** Shows a antd modal. Like using `Modal.info({...})` for example, but
 * the function is a promise that resolves when user clicks on "OK" button.
 */
export const showModal = async (
  type: NonNullable<ModalFuncProps['type']>,
  props: Omit<ModalFuncProps, 'onOk'>,
) =>
  new Promise<void>((resolve, reject) => {
    Modal[type]({
      ...props,
      onOk: () => resolve(),
    });
  });
